import keyBy from 'lodash/keyBy';
import { Minimap } from '@/models/Minimap';
import { cdnUrl } from '@/utils/urls';
import actions from './actions';
import mutations from './mutations';
import state from './state';

export default {
  namespaced: true,
  actions,
  getters: {
    exteriors: (state, _, __, rootGetters) =>
      state.exteriors.filter(({ status_id: id }) => {
        const { [id]: status } = rootGetters['project/statusMapById'];

        return !status || status.display_default;
      }),
    exteriorMapById: (_, { exteriors }) => keyBy(exteriors, 'exterior_id'),
    globalShowOverlayStatus: state => state.globalShowOverlayStatus,
    currentExterior: (_, getters, __, rootGetters) => {
      const exteriorId = rootGetters['service/exteriorId'];
      const findExteriorById = exterior => exterior.exterior_id === exteriorId;
      const findParentExterior = exterior => !exterior.parent; // exterior.parent could be null or empty string

      return getters.exteriors.find(exteriorId ? findExteriorById : findParentExterior);
    },
    minimap: (_, getters, __, rootGetters) => {
      const { exteriors, currentExterior } = getters;

      if (!currentExterior || !currentExterior.minimap ||
        !currentExterior.minimap.id) {
        return undefined;
      }

      const { id, image, north, static_north } = currentExterior.minimap;

      const data = {
        image2dmap: cdnUrl(image),
        northAngle: north,
        staticNorth: static_north,
        hotspots: exteriors
          .filter(exterior =>
            validateExteriorForMinimap(
              exterior,
              rootGetters['project/statusMapById'][exterior.status_id],
            ) &&
            exterior.minimap.id === id)
          .map(({ exterior_id: id, name, minimap: { angle, x, y } }) => ({
            id,
            title: name,
            rotation: angle * (Math.PI / 180),
            x1: x,
            y1: y,
          })),
      };

      return new Minimap(data);
    },
    poi_list: state => state.pois,
    isShowTogglePOI: state => state.isShowTogglePOI,
    isPoiMaskOn: state => state.isPoiMaskOn,
  },
  mutations,
  state,
};

// /////////////
function validateExteriorForMinimap(
  {
    display_navigator,
    minimap: {
      id, x, y, angle,
    },
  } = {},
  status,
) {
  return display_navigator && id && x != null && y != null && angle != null &&
    (!status || status.accessible);
}
